import { Component } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';
import { CreateDataFeedSharedService } from '../../create-data-feed-shared.service';

@Component({
    selector: 'cv-active-renderer',
    templateUrl: './active-renderer.component.html',
    styleUrls: ['./active-renderer.component.scss']
})
export class ActiveRendererComponent implements ICellRendererAngularComp {
    params: any;
    toggleId: string;
    isPreview: boolean;

    constructor(
        private createDataFeedSharedService: CreateDataFeedSharedService
    ) { }

    refresh() {
        return false;
    }

    agInit(params) {
        this.params = params;
        this.toggleId = 'toggle-id' + params.rowIndex;
        this.isPreview = this.params.context.componentParent.isPreview;
    }

    validGridRow() {
        let validInput = true;
        if (this.params.node.data === null || this.params.node.data === undefined) {
            validInput = false;
        }
        return validInput;
    }

    onActiveChanged(event) {
        this.createDataFeedSharedService.publishActiveChanged(this.params);
        if (this.params.context.componentParent.disableSaveBtn) {
            this.params.context.componentParent.disableSaveBtn = false;
        }
        sendMessageCXOne({hasNonSavedChanges: true});
    }

}
